import StandardLayout from '../app/alumni/StandardLayout';
import AlbumListing from '../features/album/listing/AlbumListing';
import AlbumListingService from '../features/album/listing/AlbumListingService';
import CreateAlbum from '../features/album/posting/CreateAlbum';
import AlumniDirectory from '../features/alumni/alumni-directory/AlumniDirectory';
import AlumniDirectoryService from '../features/alumni/alumni-directory/AlumniDirectoryService';
import { seniorityCodesFromSearchParams } from '../features/admin/profile-analytics-dashboard/directoryLinks';
import UpcomingBirthdays from '../features/management/birthdays/UpcomingBirthdays';
import BirthdayService from '../features/management/birthdays/BirthdayService';
import AlumniProfile from '../features/alumni/alumni-profile/AlumniProfile';
import OfficeUsage from '../features/alumni/alumni-profile/sections/OfficeUsage';
import ProfileMarker from '../features/alumni/alumni-profile/sections/admin/ProfileMarker/ProfileMarker';
import ProfileAchievements from '../features/alumni/alumni-profile/sections/ProfileAchievements';
import ProfileCertifications from '../features/alumni/alumni-profile/sections/ProfileCertifications';
import Certification from '../features/alumni/profile-edit/certification/Certification';
import ProfileBenefits from '../features/alumni/alumni-profile/sections/ProfileBenefits';
import ProfileConsent from '../features/alumni/alumni-profile/sections/ProfileConsent';
import ProfileContributions from '../features/alumni/alumni-profile/sections/ProfileContributions';
import ProfilePostGraduate from '../features/alumni/alumni-profile/sections/ProfilePostGraduate';
import ProfileDoctoral from '../features/alumni/alumni-profile/sections/ProfileDoctoral';
import ProfilePreferences from '../features/alumni/alumni-profile/sections/ProfilePreferences';
import ProfileSkills from '../features/alumni/alumni-profile/sections/ProfileSkills';
import ProfileUnderGraduate from '../features/alumni/alumni-profile/sections/ProfileUnderGraduate';
import ProfileWorkExperience from '../features/alumni/alumni-profile/sections/ProfileWorkExperience';
import UserInteraction from '../features/alumni/alumni-profile/sections/UserInteraction';
import ProfileInformation from '../features/alumni/alumni-profile/sections/admin/ProfileInformation';
import Dashboard from '../features/alumni/dashboard/Dashboard';
import DashboardService from '../features/alumni/dashboard/DashboardPageLoader';
import { Navigate } from 'react-router-dom';
import AlumniVerify from '../features/alumni/onboarding/AlumniVerify';
import Welcome from '../features/alumni/onboarding/Welcome';
import Achievement from '../features/alumni/profile-edit/achievements/Achievement';
import AlumniBreak from '../features/alumni/profile-edit/alumni-break/AlumniBreak';
import AlumniSkill from '../features/alumni/profile-edit/alumni-skills/AlumniSkill';
import AlumniBasicInfo from '../features/alumni/profile-edit/basic-info/AlumniBasicInfo';
import AlumniProfileImage from '../features/alumni/profile-edit/basic-info/AlumniProfileImage';
import Benefits from '../features/alumni/profile-edit/benefits/Benefits';
import EntranceTest from '../features/alumni/profile-edit/entrance-test/EntranceTest';
import Interest from '../features/alumni/profile-edit/interest/Interest';
import JobPreferences from '../features/alumni/profile-edit/job-preferences/JobPreferences';
import Outcome from '../features/alumni/profile-edit/outcome/Outcome';
import Bas from '../features/alumni/profile-edit/bas/Bas';
import PgEducationPreference from '../features/alumni/profile-edit/pg-education-preference/PgEducationPreference';
import PostGraduate from '../features/alumni/profile-edit/post-graduate/PostGraduate';
import ProfessionalWork from '../features/alumni/profile-edit/professional-work/ProfessionalWork';
import Scholarship from '../features/alumni/profile-edit/scholarship/Scholarship';
import StepOneCompletion from '../features/alumni/profile-edit/step-1-completion/StepOneCompletion';
import StepTwoCompletion from '../features/alumni/profile-edit/step-2-completion/StepTwoCompletion';
import StudentPreference from '../features/alumni/profile-edit/student-preference/StudentPreference';
import UgEducationPreference from '../features/alumni/profile-edit/ug-education-preference/UgEducationPreference';
import UnderGraduate from '../features/alumni/profile-edit/under-graduate/UnderGraduate';
import Entrepreneurship from '../features/alumni/profile-edit/entrepreneurship/Entrepreneurship';
import UserSchool from '../features/alumni/profile-edit/user-school/UserSchool';
import GuidanceListing from '../features/guidance/listing/GuidanceListing';
import GuidanceService from '../features/guidance/listing/GuidanceService';
import JobPosting from '../features/jobs/job-posting/JobPosting';
import JobListing from '../features/jobs/listing/JobListing';
import JobListingService from '../features/jobs/listing/JobListingService';
import EventsListing from '../features/meetings-events/listing/EventsListing';
import EventsService from '../features/meetings-events/listing/EventsService';
import Messages from '../features/messages/Messages';
import MessagesService from '../features/messages-module/MessageApiService';
import StudentActivity from '../features/student/edit/activity/StudentActivity';
import StudentBooks from '../features/student/edit/books/StudentBooks';
import Education from '../features/student/edit/education/Education';
import EntranceExam from '../features/student/edit/entrance-exams/EntranceExam';
import Parents from '../features/student/edit/parents/Parents';
import EducationDetails from '../features/student/view/sections/EducationDetails';
import EntranceExams from '../features/student/view/sections/EntranceExams';
import ExtraCurricular from '../features/student/view/sections/ExtraCurricular';
import Counselling from '../features/student/view/sections/Counselling';
import CounsellingSessions from '../features/student/view/sections/CounsellingSessions';
import CounsellingLogs from '../features/student/view/sections/CounsellingLogs';
import CommunicationLogs from '../features/student/view/sections/CommunicationLogs';
import CounsellorNotes from '../features/student/view/sections/CounsellorNotes';
import ParentInformation from '../features/student/view/sections/ParentInformation';
import Preferences from '../features/student/view/sections/Preferences';
import Preferences3c from '../features/student/view/sections/Preferences3c';
import pageLoader from '../library/Core/PageLoader';
import ErrorPage from '../library/SimpleControls/ErrorPage';
import StudentService from '../services/student.service';
import JobOutcome from '../features/alumni/profile-edit/job-outcome/JobOutcome';
import GuidanceVideos from '../features/alumni/alumni-profile/sections/admin/guidance-videos/GuidanceVideos';
import MessagesModule from '../features/messages-module/Messages';
import AdminInstituteSelection from '../features/auth/admin-institute-selection/AdminInstituteSelection';
import AskQuestion from '../features/qna/AskQuestion';
import AnswerQuestion from '../features/qna/AnswerQuestion';
import ViewMoreQuestion from '../features/qna/ViewMoreQuestion';
import StudentDashboard from '../features/qna/StudentDashboard';
import QnaApiService from '../features/qna/QnaApiService';
import OfficeMarker from '../features/alumni/alumni-profile/sections/OfficeMarker';
import AlumniStories from '../features/alumni/alumni-profile/sections/AlumniStories';
import ManageEventsService from '../features/meetings-events/add/ManageEventsService';
import ManageEvents from '../features/meetings-events/add/ManageEvents';
//import ProfileMarker from '../features/alumni/alumni-profile/sections/admin/ProfileMarker/ProfileMarker';
import TeachingJob from '../features/alumni/profile-edit/teaching-job/TeachingJob';
import ProfessionalPractice from '../features/alumni/profile-edit/professional-practice/ProfessionalPractice';
import DefenceWork from '../features/alumni/profile-edit/defence-job/DefenceWork';
import ProfessionalPracticeOutcome from '../features/alumni/profile-edit/work-outcome/professional-practice/ProfessionalPracticeOutcome';
import EntrepreneurshipOutcome from '../features/alumni/profile-edit/work-outcome/entrepreneurship/EntrepreneurshipOutcome';
import TeachingJobOutcome from '../features/alumni/profile-edit/work-outcome/teaching-job/TeachingJobOutcome';
import DefenceWorkOutcome from '../features/alumni/profile-edit/work-outcome/defence-job/DefenceWorkOutcome';
import FreeLancingWork from '../features/alumni/profile-edit/freelancing-job/FreeLancingWork';
import FreeLancingWorkOutcome from '../features/alumni/profile-edit/work-outcome/freelancing-job/FreeLancingWorkOutcome';

// added by GSK : 04-06-2025

import CounsellorStudentPreference from '../features/alumni/profile-edit/counsellor-student-preference/CounsellorStudentPreference';
import ProfileEngagement from '../features/alumni/alumni-profile/sections/ProfileEngagement';
import AlumniProfileEngagement from '../features/alumni/alumni-profile/AlumniProfileEngagement';
import ActivityMarking from '../features/student/view/sections/ActivityMarking';
import RecruiterIntentInfo from '../features/alumni/profile-edit/recruiter-intent/RecruiterIntentInfo';
import RecruiterBasicInfo from '../features/alumni/profile-edit/recruiter-basic-info/RecruiterBasicInfo';
import RecruiterProfileInformation from '../features/alumni/alumni-profile/sections/admin/RecruiterProfileInformation';
import BecomeRecruiter from '../features/alumni/profile-edit/become-recruiter/BecomeRecruiter';
import RecruiterDirectoryService from '../features/alumni/recruiter-directory/RecruiterDirectoryService';
import RecruiterDirectory from '../features/alumni/recruiter-directory/RecruiterDirectory';
import RecruiterBroadCast from '../features/broadcast/recruiter/RecruiterBroadCast';
import Journey from '../features/alumni/alumni-profile/sections/admin/Journey';
import ProgramBasicInfo from '../features/alumni/profile-edit/program-basic-info/ProgramBasicInfo';
import UGHigherStudies from '../features/alumni/profile-edit/ug-higher-studies/UGHigherStudies';
import PGHigherStudies from '../features/alumni/profile-edit/pg-higher-studies/PGHigherStudies';
import SchoolHigherStudies from '../features/alumni/profile-edit/school-higher-studies/SchoolHigherStudies';
import JobCampus from '../features/alumni/profile-edit/job-campus/JobCampus';
import InquiryManagement from '../features/alumni/inquiry-management/InquiryManagement';
import InquiryReportService from '../features/alumni/inquiry-management/InquiryReportService';
import MyEnquiries from '../features/alumni/my-enquiries/MyEnquiries';
import MyEnquiriesService from '../features/alumni/my-enquiries/MyEnquiriesService';
import ServiceProviderDashboard from '../features/alumni/service-provider-dashboard/ServiceProviderDashboard';
import ServiceProviderDashboardService from '../features/alumni/service-provider-dashboard/ServiceProviderDashboardService';
import BusinessDirectory from '../features/admin/business-directory/BusinessDirectory';
import BusinessDirectoryService from '../features/admin/business-directory/BusinessDirectoryService';
import DomainExpertDirectory from '../features/alumni/domain-expert-directory/DomainExpertDirectory';
import DomainExpertDirectoryService from '../features/alumni/domain-expert-directory/DomainExpertDirectoryService';
import EntrepreneurDirectoryService from '../features/alumni/entrepreneur-directory/EntrepreneurDirectoryService';
import EntrepreneurDirectory from '../features/alumni/entrepreneur-directory/EntrepreneurDirectory';

const createOutcomeRoute = ( path, pageName, element, includeAdditionalInfo, title ) => {
    const loader = async ({ params }) => {
        document.title = title;
        return StudentService.pageLoader({
            ...params,
            pageName,
            includeAdditionalInfo,
        });
    };

    return {
        path,
        children: [
            { index: true, loader, element },
            { path: 'outcome', loader, element }
        ]
    };
};

// for working Currently routes
const createEditRouteWithCurrent = (basePath, pageName, element, title, includeAdditionalInfo = false) => {
    const createLoader = (isCurrent) => {
        return async ({ params }) => {
            document.title = title;
            return StudentService.pageLoader({
                ...params,
                pageName,
                includeAdditionalInfo,
                isCurrent,
            });
        };
    };

    return {
        path: basePath,
        children: [
            {index: true,loader: createLoader(false),element},
            {path: 'current',loader: createLoader(true),element},
        ],
    };
};

export const alumniRoutes = {
    path: '/',
    element: <StandardLayout />,
    errorElement: <ErrorPage />,
    children: [
        {
            path: 'engagement',
            children:[
                {
                    path: ':id',
                    children: [
                        {
                            path: 'profile',
                            element: <AlumniProfileEngagement key="ALUMNI_PROFILE_ENGAGEMENT" />,
                            loader: async ({ params }) => {
                                document.title = 'Alumni Profile';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'student-profile',
                                    includeAdditionalInfo: true,
                                    includeComputedFieldsJson: true,
                                });
                            },
                            children: [
                                { path: '', element: <ProfileEngagement /> },
                                // { path: 'engagement', element: <ProfileEngagement /> }
                            ],
                        }
                    ]
                }
            ]
        },
        {
            path: 'alumni',
            children: [
                {
                    path: 'onboarding',
                    element: <Navigate to="/alumni/dashboard" replace />,
                },
                {
                    path: 'welcome',
                    loader: async ({ params }) => {
                        document.title = 'Validate your alumni status';
                        return pageLoader({ ...params, pageName: 'alumni-welcome' });
                    },
                    element: <Welcome />,
                },
                {
                    path: 'dashboard',
                    loader: async ({ params }) => {
                        document.title = 'View Dashboard';
                        return DashboardService.pageLoader({ ...params, pageName: 'alumni-dashboard' });
                    },
                    element: <Dashboard />,
                },
                {
                    path: 'directory/:selectedCard?',
                    loader: async ({ params, request }) => {
                        document.title = 'Alumni Directory';
                        const sp = new URL(request.url).searchParams;
                        const asList = (key) => {
                            const values = sp
                                .getAll(key)
                                .flatMap((v) => String(v).split(','))
                                .map((v) => v.trim())
                                .filter(Boolean);
                            return values.length ? values : undefined;
                        };
                        const seniorityLevelCode = seniorityCodesFromSearchParams(sp);
                        return AlumniDirectoryService.pageLoader({
                            ...params,
                            pageName: 'alumni-directory',
                            searchBy: 'default',
                            jobCompanyId: asList('jobCompanyId'),
                            universityId: asList('universityId'),
                            pgUniversityId: asList('pgUniversityId'),
                            industryCode: asList('industryCode'),
                            functionalAreaCode: asList('functionalAreaCode'),
                            seniorityLevelCode: seniorityLevelCode.length ? seniorityLevelCode : undefined,
                            instituteId: asList('instituteId'),
                        });
                    },
                    element: <AlumniDirectory key="directory" />,
                },
                {
                    path: 'batch-mates-directory',
                    loader: async ({ params }) => {
                        document.title = 'Alumni Directory';
                        return AlumniDirectoryService.pageLoader({ ...params, pageName: 'alumni-directory', searchBy: 'BATCH_MATES' });
                    },
                    element: <AlumniDirectory key="batch-mates-directory" />,
                },
                {
                    path: 'juniors-directory',
                    loader: async ({ params }) => {
                        document.title = 'Alumni Directory';
                        return AlumniDirectoryService.pageLoader({ ...params, pageName: 'alumni-directory', searchBy: 'JUNIORS' });
                    },
                    element: <AlumniDirectory key="juniors-directory" />,
                },
                {
                    path: 'seniors-directory',
                    loader: async ({ params }) => {
                        document.title = 'Alumni Directory';
                        return AlumniDirectoryService.pageLoader({ ...params, pageName: 'alumni-directory', searchBy: 'SENIORS' });
                    },
                    element: <AlumniDirectory />,
                },
                {
                    path: 'school-directory',
                    loader: async ({ params }) => {
                        document.title = 'School Connect';
                        return AlumniDirectoryService.pageLoader({ ...params, pageName: 'alumni-directory', searchBy: 'SCHOOL' });
                    },
                    element: <AlumniDirectory />,
                },
                {
                    path: 'birthdays',
                    loader: async ({ params }) => {
                        document.title = 'Upcoming Birthdays';
                        return BirthdayService.pageLoader({ ...params, pageName: 'alumni-birthdays' });
                    },
                    element: <UpcomingBirthdays key="alumni-birthdays" />,
                },
                {
                    path: 'inquiry-management',
                    loader: async ({ params }) => {
                        document.title = 'Inquiry Management';
                        return InquiryReportService.pageLoader({ ...params, pageName: 'inquiry-management' });
                    },
                    element: <InquiryManagement key="inquiry-management" />,
                },
                {
                    path: 'my-enquiries',
                    loader: async ({ params }) => {
                        document.title = 'My Enquiries';
                        return MyEnquiriesService.pageLoader({ ...params, pageName: 'my-enquiries' });
                    },
                    element: <MyEnquiries key="my-enquiries" />,
                },
                {
                    path: 'business-directory',
                    loader: async ({ params }) => {
                        document.title = 'Business Directory';
                        return BusinessDirectoryService.pageLoader({ ...params, pageName: 'business-directory' });
                    },
                    element: <BusinessDirectory key="business-directory" />,
                },
                {
                    path: 'service-provider-dashboard',
                    loader: async ({ params }) => {
                        document.title = 'My Service Listing';
                        return ServiceProviderDashboardService.pageLoader({ ...params, pageName: 'service-provider-dashboard' });
                    },
                    element: <ServiceProviderDashboard key="service-provider-dashboard" />,
                },                
                {
                    path: ':uiid1/messages',
                    loader: async ({ params }) => {
                        document.title = 'Messages';
                        return MessagesService.pageLoader({ ...params, pageName: 'messages', searchBy: '' });
                    },
                    element: <MessagesModule />,
                },
                {
                    path: ':id',
                    children: [
                        {
                            path: 'profile',
                            element: <AlumniProfile key="ALUMNI_PROFILE" />,
                            loader: async ({ params }) => {
                                document.title = 'Alumni Profile';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'student-profile',
                                    includeAdditionalInfo: true,
                                    includeComputedFieldsJson: true,
                                });
                            },
                            children: [
                                { path: '', element: <ProfileUnderGraduate /> },
                                // { path: 'office-usage', element: <OfficeUsage /> },
                                { path: 'office-usage', element: <OfficeMarker /> },
                                { path: 'stories', element: <AlumniStories /> },
                                { path: 'profile-marker', element: <ProfileMarker /> },
                                { path: 'journey', element: <Journey /> },
                                { path: 'profile-information', element: <ProfileInformation /> },
                                { path: 'ug', element: <ProfileUnderGraduate /> },
                                { path: 'pg', element: <ProfilePostGraduate /> },
                                { path: 'doctoral', element: <ProfileDoctoral /> },
                                { path: 'work', element: <ProfileWorkExperience /> },
                                { path: 'mentoring-interests', element: <ProfileConsent /> },
                                { path: 'achievements', element: <ProfileAchievements /> },
                                { path: 'certifications', element: <ProfileCertifications /> },
                                { path: 'contributions', element: <ProfileContributions /> },
                                { path: 'skills', element: <ProfileSkills /> },
                                { path: 'preferences', element: <ProfilePreferences /> },
                                { path: 'interaction', element: <UserInteraction /> },
                                { path: 'benefits', element: <ProfileBenefits /> },

                                { path: 'preference', element: <Preferences /> },
                                { path: 'entrance-exams', element: <EntranceExams /> },
                                { path: 'education', element: <EducationDetails /> },
                                { path: 'parent-info', element: <ParentInformation /> },
                                { path: 'job-preferences', element: <ProfilePreferences /> },
                                { path: 'extra-curricular', element: <ExtraCurricular /> },
                                { path: 'guidance-videos', element: <GuidanceVideos /> },
                                { path: '3c-preference', element: <Preferences3c /> },
                                { path: 'counselling', element: <Counselling /> },

                                { path: 'sessions', element: <CounsellingSessions /> },
                                { path: 'counselling-logs', element: <CounsellingLogs /> },
                                { path: 'communication-logs', element: <CommunicationLogs /> },
                                { path: 'counsellor-notes', element: <CounsellorNotes /> },
                                { path: 'engagement', element: <ProfileEngagement /> },
                                { path: 'activity-marking', element: <ActivityMarking /> },
                                { path: 'recruiter-profile', element: <RecruiterProfileInformation /> }
                            ],
                        },
                        {
                            path: 'alumni-verify',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-verify',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <AlumniVerify />,
                        },
                        {
                            path: 'recruiter-intent',
                            loader: async ({ params }) => {
                                document.title = 'Update Recruiter Information';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'recruiter-intent',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <RecruiterIntentInfo />,
                        },
                        {
                            path: 'info',
                            loader: async ({ params }) => {
                                document.title = 'Update Basic Information';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-basic-info',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <AlumniBasicInfo />,
                        },
                        {
                            path: 'become-recruiter',
                            loader: async ({ params }) => {
                                document.title = 'Update Recruiter Information';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-become-recruiter',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <BecomeRecruiter />,
                        },
                        {
                            path: 'recruiter-basic-info',
                            loader: async ({ params }) => {
                                document.title = 'Update Recruiter Basic Information';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'recruiter-basic-info',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <RecruiterBasicInfo />,
                        },
                        {
                            path: 'bas',
                            loader: async ({ params }) => {
                                document.title = 'Book a Session';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'book-a-session',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <Bas />,
                        },
                         {
                            path: 'job-campus',
                            loader: async ({ params }) => {
                                document.title = 'Work Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-outcome-work',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <JobCampus />,
                        },
                        createOutcomeRoute(
                            'ug',
                            'alumni-undergraduate',
                            <UnderGraduate />,
                            false,
                            'Update Education Details'
                        ),
                        createEditRouteWithCurrent(
                            ':editId?/entrepreneurship',
                            'alumni-entrepreneurship',
                            <Entrepreneurship />,
                            'Entrepreneurship Details'
                        ),
                        {
                            path: ':editId?/entrepreneurship-outcome',
                            loader: async ({ params }) => {
                                document.title = 'Entrepreneurship Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-entrepreneurship-outcome',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <EntrepreneurshipOutcome />,
                        },
                        createEditRouteWithCurrent(
                            ':editId?/teaching-experience',
                            'alumni-teaching-work',
                            <TeachingJob />,
                            'Teaching Work'
                        ),
                        {
                            path: 'teaching-experience-outcome',
                            loader: async ({ params }) => {
                                document.title = 'Teaching Outcome Work';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-teaching-outcome-work',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <TeachingJobOutcome />,
                        },
                        createEditRouteWithCurrent(
                            ':editId?/professional-practice-experience',
                            'alumni-professional-practice',
                            <ProfessionalPractice />,
                            'Professional Details'
                        ),
                        {
                            path: ':editId?/professional-practice-experience-outcome',
                            loader: async ({ params }) => {
                                document.title = 'Professional Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-professional-practice-outcome',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <ProfessionalPracticeOutcome />,
                        },
                        createEditRouteWithCurrent(
                            ':editId?/defence-experience',
                            'defence-work-experience',
                            <DefenceWork />,
                            'Defence Details'
                        ),
                        {
                            path: 'defence-experience-outcome',
                            loader: async ({ params }) => {
                                document.title = 'Defence Outcome Work';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'defence-experience-outcome',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <DefenceWorkOutcome/>,
                        },
                        createEditRouteWithCurrent(
                            ':editId?/freelancing-experience',
                            'alumni-freelancing',
                            <FreeLancingWork />,
                            'Freelancing Details'
                        ),
                        {
                            path: ':editId?/freelancing-experience-outcome',
                            loader: async ({ params }) => {
                                document.title = 'Freelancing Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-freelancing-outcome',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <FreeLancingWorkOutcome />,
                        },
                        {
                            path: 'job-outcome',
                            loader: async ({ params }) => {
                                document.title = 'Work Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-outcome-work',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <JobOutcome />,
                        },
                        createOutcomeRoute(
                            'pg',
                            'alumni-pg-details',
                            <PostGraduate />,
                            false,
                            'Update Education Details 12'
                        ),
                        {
                            path: 'scholarship',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-scholarship',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <Scholarship />,
                        },
                        {
                            path: 'entrance-test',
                            loader: async ({ params }) => {
                                document.title = 'Update Exam Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-entrance-test',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <EntranceTest />,
                            errorElement: <ErrorPage />,
                        },
                        createEditRouteWithCurrent(
                            ':editId?/work',
                            'alumni-professional-work',
                            <ProfessionalWork />,
                            'Update Work Details'
                        ),
                        createOutcomeRoute(
                            'ug-education-preference',
                            'alumni-ug-education-preferences',
                            <UgEducationPreference />,
                            true,
                            'Update Study Preferences'
                        ),
                        createOutcomeRoute(
                            'pg-education-preference',
                            'alumni-pg-education-preferences',
                            <PgEducationPreference />,
                            true,
                            'Update Study Preferences'
                        ),
                        createOutcomeRoute(
                            'job-preferences',
                            'alumni-job-preferences',
                            <JobPreferences />,
                            true,
                            'Update Job Preferences'
                        ),
                        {
                            path: 'achievements',
                            loader: async ({ params }) => {
                                document.title = 'Add Achievements';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-achievement',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <Achievement />,
                        },
                        {
                            path: 'certifications',
                            loader: async ({ params }) => {
                                document.title = 'Add Certifications';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-certification',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <Certification />,
                        },
                        {
                            path: 'skills',
                            loader: async ({ params }) => {
                                document.title = 'Update Skill Profile';
                                return StudentService.pageLoader({ ...params, pageName: 'alumni-skills', includeAdditionalInfo: true });
                            },
                            element: <AlumniSkill />,
                        },
                        {
                            path: 'mentoring-interests',
                            loader: async ({ params }) => {
                                document.title = 'Mentoring Interests';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-mentoring-interests',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <Interest />,
                        },
                        {
                            path: 'profile-picture',
                            loader: async ({ params }) => {
                                document.title = 'Update Profile Picture';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-profile-picture',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <AlumniProfileImage />,
                        },
                        {
                            path: 'benefits',
                            loader: async ({ params }) => {
                                document.title = 'Get Benefits';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-benefits',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <Benefits />,
                        },
                        {
                            path: 'school-higher-studies',
                            loader: async ({ params }) => {
                                document.title = 'Update Schooling Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'student-school-outcomes',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <SchoolHigherStudies />,
                        },
                        {
                            path: 'ug-higher-studies',
                             loader: async ({ params }) => {
                                document.title = 'Update higher studies';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-ug-higher-studies',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <UGHigherStudies />,
                        },
                         {
                            path: 'pg-higher-studies',
                             loader: async ({ params }) => {
                                document.title = 'Update higher studies';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-pg-higher-studies',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <PGHigherStudies />,
                        },
                        {
                            path: 'step-one',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({ ...params, pageName: null, includeAdditionalInfo: true });
                            },
                            element: <StepOneCompletion />,
                        },
                        {
                            path: 'step-two',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({ ...params, pageName: null, includeAdditionalInfo: true });
                            },
                            element: <StepTwoCompletion />,
                        },
                        {
                            path: 'student-took-a-break',
                            loader: async ({ params }) => {
                                document.title = 'Update Profile';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'student-took-a-break',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <AlumniBreak />,
                        },
                        {
                            path: 'student-school',
                            loader: async ({ params }) => {
                                document.title = 'Update Schooling Details';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'student-school-outcomes',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <UserSchool />,
                        },
                        {
                            path: 'select-institute/:instituteId?/:redirectTo?',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'admin-select-instiitute',
                                    includeAdditionalInfo: false,
                                });
                            },
                            errorElement: <ErrorPage />,
                            element: <AdminInstituteSelection pageTitle="Choose Institute" />,
                        },
                         {
                            path: 'program-basic-info',
                            loader: async ({ params }) => {
                                document.title = 'Update Program Basic Info';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-program-details',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <ProgramBasicInfo />,
                        },
                        {
                            path: 'outcome',
                            loader: async ({ params }) => {
                                document.title = 'Update Program Outcome';
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'alumni-program-outcomes',
                                    includeAdditionalInfo: false,
                                });
                            },
                            element: <Outcome />,
                        },
                         createOutcomeRoute(
                            'student-preference',
                            'student-education-preferences',
                            <StudentPreference />,
                            true,
                            'Update Study Preferences'
                        ),
                        {
                            path: 'parent-info',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({ ...params, pageName: 'student-parents', includeAdditionalInfo: true });
                            },
                            element: <Parents />,
                        },
                        {
                            path: 'education',
                            loader: async ({ params }) => {
                                document.title = 'Update Education Details';
                                return StudentService.pageLoader({ ...params, pageName: 'student-education' });
                            },
                            element: <Education />,
                        },
                        {
                            path: 'entrance-exam',
                            loader: async ({ params }) => {
                                document.title = 'Update Exam Details';
                                return StudentService.pageLoader({ ...params, pageName: 'student-entrance-exams' });
                            },
                            element: <EntranceExam />,
                        },
                        {
                            path: 'books',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'student-reading-interest',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <StudentBooks />,
                        },
                        {
                            path: 'activity',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({ ...params, pageName: 'student-activity', includeAdditionalInfo: true });
                            },
                            element: <StudentActivity />,
                        },
                        {
                            path: 'counsellor-student-preference',
                            loader: async ({ params }) => {
                                return StudentService.pageLoader({
                                    ...params,
                                    pageName: 'counsellor-student-education-preferences',
                                    includeAdditionalInfo: true,
                                });
                            },
                            element: <CounsellorStudentPreference />,
                        },
                    ],
                },
            ],
        },
         {
            path: 'domain-expert',
            children: [
                {
                    path: 'directory',
                    loader: async () => {
                        document.title = 'Domain Expert Directory';
                        return DomainExpertDirectoryService.pageLoader({ pageName: 'domain-expert-directory' });
                    },
                    element: <DomainExpertDirectory key="domain-expert-directory" />,
                },
            ],
        },
        {
            path: 'entrepreneur',
            children: [
                {
                    path: 'directory',
                    loader: async ({ request }) => {
                        document.title = 'Entrepreneur Directory';
                        const searchParams = new URL(request.url).searchParams;
                        return EntrepreneurDirectoryService.pageLoader({
                            pageName: 'entrepreneur-directory',
                            selectedCard: searchParams.get('selectedCard') || '',
                        });
                    },
                    element: <EntrepreneurDirectory key="entrepreneur-directory" />,
                },
            ],
        },
       {
            path: 'recruiter',
            children: [
               {
                    path: 'directory/:type?',
                    loader: async ({ params }) => {
                        document.title = 'Recruiter Directory';
                        return RecruiterDirectoryService.pageLoader({ ...params, pageName: 'recruiter-directory', searchBy: 'default' });
                    },
                    element: <RecruiterDirectory key="directory" />,
                },
                {
                    path: 'create-broadcast-step-4?',
                     loader: async ({ params }) => {
                        document.title = 'Recruiter Directory';
                        return RecruiterDirectoryService.pageLoader({ ...params, pageName: 'recruiter-broadcast'});
                    },
                    element: <RecruiterBroadCast key="recruiter-broadcast" />,
                },
            ]
        },
        
        {
            path: 'messages-old',
            loader: async ({ params }) => {
                document.title = 'Messages';
                return MessagesService.pageLoader({ ...params, pageName: 'messages', searchBy: '' });
            },
            element: <Messages />,
        },
        {
            path: 'student-messages',
            loader: async ({ params }) => {
                document.title = 'Messages';
                return MessagesService.pageLoader({ ...params, pageName: 'messages', searchBy: 'STUDENT' });
            },
            element: <Messages key="STUDENT" />,
        },
        {
            path: 'alumni-messages',
            loader: async ({ params }) => {
                document.title = 'Messages';
                return MessagesService.pageLoader({ ...params, pageName: 'messages', searchBy: 'ALUMNI' });
            },
            element: <Messages key={'ALUMNI'} />,
        },
        {
            path: 'messages-old/:action/:ids',
            loader: async ({ params }) => {
                const ids = params.ids.split(',');
                return MessagesService.pageLoader({ ...params, ids, pageName: 'messages', newMessageMode: true });
            },
            element: <Messages />,
        },
        {
            path: 'job-posting',
            children: [
                {
                    path: '',
                    loader: async ({ params }) => {
                        document.title = 'Jobs & Internships';
                        return JobListingService.pageLoader({ ...params, pageName: 'alumni-job-listing', searchBy: 'ACTIVE_LIST' });
                    },
                    element: <JobListing />,
                },
                {
                    path: ':id',
                    loader: async ({ params }) => {
                        document.title = 'Post a Job';
                        return pageLoader({ ...params, pageName: 'alumni-job-posting' });
                    },
                    element: <JobPosting />,
                },
            ],
        },
        {
            path: 'memories',
            children: [
                {
                    path: '',
                    loader: async ({ params }) => {
                        document.title = 'Memories';
                        return AlbumListingService.pageLoader({ ...params, pageName: 'alumni-album', searchBy: 'default' });
                    },
                    element: <AlbumListing />,
                },
                {
                    path: ':id',
                    loader: async ({ params }) => {
                        document.title = 'Create Album';
                        return pageLoader({ ...params, pageName: 'alumni-album' });
                    },
                    element: <CreateAlbum />,
                },
            ],
        },
        {
            path: 'guidance',
            children: [
                {
                    path: '',
                    loader: async ({ params }) => {
                        document.title = 'Guidance Videos';
                        return GuidanceService.pageLoader({ ...params, pageName: 'alumni-guidance', searchBy: 'default' });
                    },
                    element: <GuidanceListing />,
                },
            ],
        },
        {
            path: 'events',
            children: [
                {
                    path: 'add',
                    loader: async ({ params }) => {
                        document.title = 'Create Event';
                        return ManageEventsService.pageLoader({ ...params, pageName: 'event-add' });
                    },
                    element: <ManageEvents />,
                },
                {
                    path: ':searchBy',
                    loader: async ({ params }) => {
                        document.title = params.searchBy === 'upcoming' ? 'Upcoming Events' : 'Past Events';
                        return EventsService.pageLoader({ ...params, pageName: 'meetings_events' });
                    },
                    element: <EventsListing />,
                },
            ],
        },
        {
            path: 'messages/:uiid1?/:uiid2?/:uiid3?',
            loader: async ({ params }) => {
                document.title = 'Messages';
                return MessagesService.pageLoader({ ...params, pageName: 'messages', searchBy: '' });
            },
            element: <MessagesModule />,
        },
        {
            path: 'ask-question',
            loader: async ({ params }) => {
                document.title = 'QNA';
                return QnaApiService.pageLoader({ ...params, pageName: 'qna', searchBy: '' });
            },
            element: <AskQuestion />,
        },
        {
            path: 'qna-dashboard',
            loader: async ({ params }) => {
                document.title = 'Student QNA';
                return QnaApiService.pageLoader({ ...params, pageName: 'qna', searchBy: '' });
            },
            element: <StudentDashboard />,
        },
        {
            path: 'answer-question',
            loader: async ({ params }) => {
                document.title = 'QNA';
                return QnaApiService.pageLoader({ ...params, pageName: 'qna', searchBy: '' });
            },
            element: <AnswerQuestion />,
        },
        {
            path: 'view-more-question',
            loader: async ({ params }) => {
                document.title = 'QNA';
                return QnaApiService.pageLoader({ ...params, pageName: 'qna', searchBy: '' });
            },
            element: <ViewMoreQuestion />,
        },
    ],
};
